import React from "react";
import { FiBox } from "react-icons/fi";
import ProductAssetImage from "./ProductAssetImage";
export default function ItemCatalogThumbnail({ item, languageId, config }) {
  const label = languageId === "es" ? "Imagen" : languageId === "ca" ? "Imatge" : "Image";
  const placeholder = <FiBox aria-hidden="true" />;
  return <span className="ifm-itemThumbnail" role="img" aria-label={`${label}: ${item.name}`}>
    {item.thumbnail_asset_id ? <ProductAssetImage assetId={item.thumbnail_asset_id} context={{ item_id: item.id }} config={config} variant="thumbnail" alt={item.name} placeholder={placeholder} unavailable={placeholder} /> : placeholder}
  </span>;
}
